import { Observable, of } from 'rxjs';
import { flatMap, catchError } from 'rxjs/operators';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Client } from '../models/clients/client';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Injectable()
export class ClientResolver implements Resolve<Client> {
    constructor(private api: ClientsApiService, private spinner: NgxSpinnerService) { }

    resolve(
        route: ActivatedRouteSnapshot,
    ): Observable<Client> {
        this.spinner.show();
        const id = route.params.id;
        if (!id || !/^\d+$/.test(id)) {
            this.spinner.hide();
            return of(null);
        }
        return this.api.getClientSummary(id)
            .pipe(catchError(errors => {
                console.log(errors)
                return of(null);
            }))
            .pipe(flatMap(p => {
                this.spinner.hide();
                return of(p)
            }));
    }
}
